module.exports = __webpack_public_path__ + "static/media/solution-tube-k_-closed.e1bee9fd.svg";